import React from "react";
import { Link } from "react-router-dom";

export default function Banner() {
  return (
    <section className="banner-section">
      <div className="homebanner-text">
        <h1 className="heading">Elegance Shaped From Your Story</h1>
        <p style={{ textTransform: "none" }}>
          Book a private consultation with Sonam Brahme and bring your bridal vision to life, in-studio or over video.
        </p>
        <p style={{ textTransform: "none" }}>
          From the first conversation to the final fitting, a bespoke bridal journey, just for you.
        </p>

        <Link to="/contact-us#contact-form" className="default-btn">
          Book My Consultation
        </Link>
      </div>

      <img src="/image/banner-1.webp" className="img-responsive" alt="banner" />
      <div className="banner-overlay"></div>
    </section>
  );
}
